module.exports = __webpack_public_path__ + "img/ch-101-e.asm.cf3dc6d9.jpg";